import { MouseEvent, ReactNode } from 'react'
import { navigate } from 'gatsby'
import clsx from 'clsx'
import { ArrowButton, BackButton, Skeleton, Title } from 'components/common'
import * as styles from './styles.module.css'

export interface ContainerProps {
  title: string
  tags?: ReactNode | ReactNode[]
  actions?: ReactNode | ReactNode[]
  loading?: boolean
  pagination?: {
    prev?: string
    next?: string
  }
  children?: ReactNode
  onBack?: (e: MouseEvent<HTMLButtonElement>) => void
}

const Container = ({
  title,
  tags,
  loading,
  actions,
  pagination,
  children,
  onBack,
}: ContainerProps): JSX.Element => (
  <>
    <div className={clsx(styles.container)}>
      <div className={clsx(styles.section)}>
        <div className={clsx(styles.section__header)}>
          <div className={clsx(styles.header__row)}>
            {onBack && (
              <div className={clsx(styles.header__back)}>
                <BackButton
                  className={clsx(styles.header__back_button)}
                  disabled={loading}
                  onClick={onBack}
                />
              </div>
            )}

            <div className={clsx(styles.header__title_wrapper)}>
              <div className={clsx(styles.header__title_and_subtitle_wrapper)}>
                <div className={clsx(styles.header__title)}>
                  {loading ? (
                    <Skeleton active title paragraph={false} />
                  ) : (
                    <Title level={1}>{title}</Title>
                  )}
                </div>
                <div className={clsx(styles.header__title_metadata)}>
                  {!loading && tags}
                </div>
              </div>
            </div>
            <div className={clsx(styles.header__actions)}>
              <div className={clsx(styles.header__actions_menu)}>
                {!loading && actions}
              </div>
              <div className={clsx(styles.header__actions_pagination)}>
                <ArrowButton
                  direction="left"
                  disabled={typeof pagination?.prev !== 'string'}
                  hidden={typeof pagination === 'undefined'}
                  onClick={() => navigate(pagination.prev)}
                />
                <ArrowButton
                  direction="right"
                  disabled={typeof pagination?.next !== 'string'}
                  hidden={typeof pagination === 'undefined'}
                  onClick={() => navigate(pagination.next)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={clsx(styles.layout)}>{children}</div>
    </div>
  </>
)

export default Container
